import Controller from '@ember/controller';

import { ContentWrapper } from 'register-partners-js/react/components/content-wrapper';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class NotEligibleController extends Controller {
  styles = styles;
  contentWrapper = ContentWrapper;
  mainLayout = MainLayout;
}
